import React, { useState, useEffect,Fragment } from 'react';
import propTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import SiteInformationForm from 'components/fileComplain/formSection/siteInformationForm/siteInformationForm';
import Loader from 'components/sales/Loader/loader';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';


const headers = ['Site Number', 'Site Name', 'Site Address','Remark', 'Actions'];

const FileComplain = ({
  getSiteInformation,
  siteInfo = [],
  locationCity,
  locationZone,
  locationArea,
  getSiteTypes,
  siteTypes,
  cities,
  zones,
  areas,
}) => {
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showFilter, setShowFilter] = useState('none');
  const statusCodes = [4,21,22,23,24,25];

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };
  const filterToggle = () => {
    if(showFilter === 'none'){
      setShowFilter('block');
    }else{
      setShowFilter('none');
    }
    
  };
  useEffect(() => {
    const tableData = ['site_id', 'site_no', 'site_name', 'site_address','disableRemark'];
    if (siteInfo.length > 0) {
      const data = siteInfo.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          element.status !== 16 && element.status !== 4 && statusCodes.includes(element.status) !== true ?
          {
            Actions: {
              name: 'Create Complain',
              link: `/dashboard/create-complain/${element.site_id}`,
            },
          } : statusCodes.includes(element.status) == true ? {
              Actions: {
                name: element?.status_name,
                link: ``,
              },
          } : 
          {
            Actions: {
              name: 'Disabled',
              link: ``,
            },
          } 
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
    }
    filterToggle();
  }, [siteInfo]);

  return (
    <Layout title={localization.createComplain} 
    Buttons={headerBtns}
    isLoading={isLoading}>
      <PanelCardWithHeading
        title={localization.complaintFilter}
        
        isLoading={isLoading}
      >
        <SiteInformationForm
          showFilter={showFilter}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          locationCity={locationCity}
          locationZone={locationZone}
          locationArea={locationArea}
          getSiteTypes={getSiteTypes}
          cities={cities}
          zones={zones}
          areas={areas}
          siteTypes={siteTypes}
          siteInformationData={async (val) => {
            setIsLoading(true);
            await getSiteInformation(val);
            setIsLoading(false);
          }}
        />
      </PanelCardWithHeading>
      {siteInfo.length > 0 && (
        <PanelCardWithHeading title={localization.siteDetails}>
          <TableSection
            data={listData}
            isId={false}
            headers={headers}
            detailList={siteInfo}
          />
        </PanelCardWithHeading>
      )}
      <Loader isLoading={isLoading} />
    </Layout>
  );
};

FileComplain.propTypes = {
  locationCity: propTypes.func,
};

export default FileComplain;
